import clsx from 'clsx';
import { Col, Form } from 'react-bootstrap';
import ReactInputMask from 'react-input-mask';
import { InputProps } from '../types';


export default function PhoneInput(props: InputProps) {
    const groupProps = {
        as: props.isCol ? Col : undefined,
        className: clsx(props.withMarginBottom && 'mb-3' ,props.groupClassName),
        sm: props.sm,
    }
    // useEffect(() => {
    //     console.log('Mudou value', props.value)
    //     if(props.value && props.value !== value) setValue(props.value)
    // },[props.value])
    return (
        <Form.Group {...groupProps}>
            <Form.Label className={clsx(props.required && 'required')} >{props.label ?? 'Telefone'}</Form.Label>
            <ReactInputMask
                mask="(99) 99999-9999"
                maskChar="_"
                // alwaysShowMask
                placeholder='(00) 00000-0000'
                name={props.name}
                id={props.id}
                // defaultValue={props.defaultValue ?? props.value ?? ''}
                onChange={props.onChange}
                value={props.value}
            >
                {((inputProps: any) => (
                    <Form.Control
                        type={props.type ?? 'text'}
                        className={clsx('form-control-solid', props.className)}
                        {...inputProps}
                    />
                )) as any}
            </ReactInputMask>
            {props.children}
        </Form.Group>
    )
}